import React, { PropTypes } from 'react';
import { metadataIdFixer } from '@bibliocommons/utils-link';

import './CompactTitle.scss';

export default function CompactTitle({ title, subtitle, renderAsLink, id }) {
  if (renderAsLink && typeof id === 'string') {
    return (
      <div className="cp-compact-title">
        {title &&
          <span className="bib-title">
            <a href={`/item/show/${metadataIdFixer(id)}`}>
              {title}
            </a>
          </span>
        }
        {subtitle &&
          <span className="sub-title">
            {subtitle}
          </span>
        }
      </div>
    );
  }

  return (
    <div className="cp-compact-title">
      {title &&
        <span className="bib-title">
          {title}
        </span>
      }
      {subtitle &&
        <span className="sub-title">
          {subtitle}
        </span>
      }
    </div>
  );
}

CompactTitle.defaultProps = {
  renderAsLink: false
};

// Note: Can't pass bib may or may not be derived from a bib
CompactTitle.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  renderAsLink: PropTypes.bool,
  id: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/shared/CompactTitle/CompactTitle.jsx